// DS: i2.4.1
import React from 'react';
import IconWrap from '../../IconWrap';
const GalleryTorpedo = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,1 L0,7 C6.76353751e-17,7.55228475 0.44771525,8 1,8 L5,8 C5.55228475,8 6,7.55228475 6,7 L6,1 C6,0.44771525 5.55228475,-1.01453063e-16 5,0 L1,0 C0.44771525,1.01453063e-16 -6.76353751e-17,0.44771525 0,1 Z M8,1 L8,7 C8,7.55228475 8.44771525,8 9,8 L17,8 C17.5522847,8 18,7.55228475 18,7 L18,1 C18,0.44771525 17.5522847,-1.01453063e-16 17,0 L9,0 C8.44771525,1.01453063e-16 8,0.44771525 8,1 Z M0,11 L0,17 C6.76353751e-17,17.5522847 0.44771525,18 1,18 L10,18 C10.5522847,18 11,17.5522847 11,17 L11,11 C11,10.4477153 10.5522847,10 10,10 L1,10 C0.44771525,10 -6.76353751e-17,10.4477153 0,11 Z M13,11 L13,17 C13,17.5522847 13.4477153,18 14,18 L17,18 C17.5522847,18 18,17.5522847 18,17 L18,11 C18,10.4477153 17.5522847,10 17,10 L14,10 C13.4477153,10 13,10.4477153 13,11 Z",
        transform: "translate(3 3)"
    })));
};
GalleryTorpedo.displayName = 'GalleryTorpedo';
export default GalleryTorpedo;

//# sourceMappingURL=GalleryTorpedo.js.map